/**
 *  SmartMissile
 *
 *  Created by Legman on 21/04/2017.
 *
 */

import Common   from "../Common";
import Missile  from "./Missile";

/**
 * @class
 * @extends Missile
 */
export default class SmartMissile extends Missile {
    /**
     * @param {RaceCar} owner
     */
    constructor(owner) {
        super(owner);

        this.turnAccel = 12000;
        this.turnDamping = 0.914;

        this.view.texture = Common.assets.getTexture("powerup_missile_smart_object_01");
        this.view.tint = 0x000099;

        /**
         * @member {number}
         */
        this.minSeekDistance = 0;

        /**
         * @member {number}
         */
        this.maxSeekDistance = 16;
    }

    /**
     */
    init() {
        super.init();
    }

    /**
     * @param {number} dt
     */
    update(dt) {
        if (this._armed) {
            const car = this.seekTarget();
            if (car) {
                let target = car.offset.x;

                const width = 580;
                if (Math.abs(target) > width) {
                    target = (target / Math.abs(target)) * width;
                }

                const distance = target - this.offset.x;
                const direction = distance / Math.abs(distance);
                const time = 1.6;

                const radius = 280;
                if (distance > radius) {
                    this.turnSpeed = direction * this.turnAccel;
                } else {
                    this.turnSpeed = direction * (this.turnAccel * Math.min(1, Math.abs(distance / radius)));
                }
                this.turnSpeed /= time;
            }
        }
        super.update(dt);
    }

    /**
     * @returns {RaceEntity}
     */
    seekTarget() {
        let minDistance = Number.MAX_SAFE_INTEGER;
        let result = null;
        const cars = Common.game.getCars();

        for (let i = 0; i < cars.length; ++ i) {
            const car = cars[i];
            if (car === this._owner) continue;

            const diff = this.getDistanceTo(car);
            if (diff > this.minSeekDistance && diff < this.maxSeekDistance) {
                if (diff < minDistance) {
                    result = car;
                    minDistance = diff;
                }
            }
        }
        return result;
    }

    /**
     * @protected
     */
    _createTrailEmitter() {
        const assets = Common.assets;
        let config = assets.getJSON("particle_emitter_missile_smart_trail");
        this._trailEmitter = new PIXI.particles.Emitter(this._view, [
            assets.getTexture("particles_rockettrail_00"),
            assets.getTexture("particles_rockettrail_01"),
            assets.getTexture("particles_rockettrail_02"),
            assets.getTexture("particles_rockettrail_03")
        ], config);
        this._trailEmitter.emit = true;
    }
}